import HomePage from "./home";

const Index = HomePage;

export default Index;
